/**
 * Read the before/after evidence photos off a repair record.
 *
 * Mirrors the fallback the API applies to legacy rows: those predate before/after and
 * carry only proof_photo_url, which stands in for both. Records also arrive in two
 * shapes — snake_case straight from the API, camelCase from older client state.
 *
 * An in-progress repair legitimately has a before photo and no after photo, so an empty
 * afterPhotoUrl is a normal state rather than missing data.
 */
export function repairPhotoUrls(record) {
  if (!record) return { beforePhotoUrl: '', afterPhotoUrl: '' };
  const proof = record.proof_photo_url || record.proofPhotoUrl || '';
  return {
    beforePhotoUrl: record.before_photo_url || record.beforePhotoUrl || proof || '',
    afterPhotoUrl: record.after_photo_url || record.afterPhotoUrl || proof || '',
  };
}
